import * as Haptics from 'expo-haptics';
import i18n from '@/utils/i18n';
import React from 'react';
import { Icons, Typography, View, XStack } from '@usepepper/sprout-kit-ui';
import { Pressable } from 'react-native';
import { useIsMobileBottomNavLayout } from '@/experiences/sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';

// Intentional literal: no sk spacing token maps to the 3px design gap.
const GAP = 3;
const PHONE_MIN_HEIGHT = 24;
const PHONE_EXPANDED_MIN_HEIGHT = 32;
const PHONE_EXPANDED_MIN_WIDTH = 40;
const HIT_SLOP = { bottom: 15, left: 8, right: 8, top: 15 };

interface CategoryTogglePillProps {
  count: number;
  expanded: boolean;
  onPress: () => void;
}

export const CategoryTogglePill: React.FC<CategoryTogglePillProps> = ({
  count,
  expanded,
  onPress,
}) => {
  const isPhone = useIsMobileBottomNavLayout();

  // Use a "weightier" haptic when opening, and a lighter when closing
  const handlePress = () => {
    if (isPhone) {
      if (expanded) {
        Haptics.selectionAsync();
      } else {
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
      }
    }
    onPress();
  };

  return (
    <Pressable
      accessibilityLabel={i18n.t('view_more')}
      accessibilityRole="button"
      accessibilityState={{ expanded }}
      hitSlop={HIT_SLOP}
      onPress={handlePress}
    >
      <XStack
        alignItems="center"
        backgroundColor="$bgSecondaryDefault"
        borderRadius="$round"
        gap={GAP}
        justifyContent="center"
        minHeight={
          isPhone
            ? expanded
              ? PHONE_EXPANDED_MIN_HEIGHT
              : PHONE_MIN_HEIGHT
            : 0
        }
        minWidth={isPhone && expanded ? PHONE_EXPANDED_MIN_WIDTH : 0}
        paddingHorizontal="$8"
        paddingVertical={isPhone ? 0 : 4}
      >
        {!expanded ? (
          <Typography
            fontWeight="$normal"
            size={isPhone ? '$2xs' : '$xs'}
            variant="label"
          >
            {count}
          </Typography>
        ) : null}
        {/* Rotation goes on a View: a transform array on the svg itself is
            dropped by react-native-web. */}
        <View rotate={expanded ? '180deg' : '0deg'}>
          <Icons.ChevronDown
            color="$iconPrimary"
            size={isPhone ? '$16' : '$14'}
          />
        </View>
      </XStack>
    </Pressable>
  );
};
